import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccionTarea } from '../models/Tarea';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ComentarService {

  private URL_COMENTARIO = environment.apiUrl + "ta/co"

  constructor(
    private http: HttpClient
  ) { }

  create(accionTareas: AccionTarea[]): Observable<string> {
    return this.http.post(this.URL_COMENTARIO, accionTareas, {
      responseType: 'text',
    });
  }
}
